import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';
import { Skeleton } from '@cobliteam/ui/components';
import { format } from '@cobliteam/utils/date';
import { SummaryVehicleMedia, SummaryVehicleMediaItem } from '../../../../Summary/SummaryVehicleMedia';

export interface DialogMediaInfoProps {
  mediaId?: string;
  showDriver?: boolean;
}

const DialogMediaInfo = ({ mediaId, showDriver }: DialogMediaInfoProps) => {
  const { data: mediaView } = useGetMediaView(mediaId);

  const mediaData = mediaView?.mediaInfo;

  if (!mediaData) {
    return (
      <div className='flex gap-2 align-middle text-gray-dark'>
        <Skeleton key={0} width={100} height={19} />

        {showDriver && <Skeleton key={0} width={100} height={19} />}
        <Skeleton key={0} width={100} height={19} />

        <Skeleton key={0} width={100} height={19} />
      </div>
    );
  }

  const { driver, licensePlate = 'Sem placa', vehicleGroup, timestamp } = mediaData;
  const driverName = driver?.name || 'Sem Motorista';
  const { name: groupName = 'Sem grupo' } = vehicleGroup || {};
  const formatDate = format(timestamp, 'dd MMM yyyy HH:mm');

  return (
    <SummaryVehicleMedia>
      {showDriver && <SummaryVehicleMediaItem type='driver'>{driverName}</SummaryVehicleMediaItem>} <SummaryVehicleMediaItem type='dateTime'>{formatDate}</SummaryVehicleMediaItem>
      <SummaryVehicleMediaItem type='licensePlate'>{licensePlate}</SummaryVehicleMediaItem>
      <SummaryVehicleMediaItem type='vehicleGroup'>{groupName}</SummaryVehicleMediaItem>
    </SummaryVehicleMedia>
  );
};

export default DialogMediaInfo;
